import { useState, useRef, useEffect } from "react";
import { api } from "@/lib/api";
import { X, Send } from "lucide-react";

const sid = "elia-" + Math.random().toString(36).slice(2, 10);

export const ChatWidget = () => {
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState([{ role: "assistant", text: "Hi! I'm Elia, your travel assistant ✈️ Ask me about flights, hotels, holidays, Umrah packages, vouchers or your booking." }]);
  const [input, setInput] = useState("");
  const [busy, setBusy] = useState(false);
  const end = useRef(null);

  useEffect(() => { end.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs, open]);

  const send = async (e) => {
    e.preventDefault();
    const text = input.trim();
    if (!text || busy) return;
    setMsgs((m) => [...m, { role: "user", text }]);
    setInput(""); setBusy(true);
    try {
      const { data } = await api.post("/chat", { session_id: sid, message: text });
      setMsgs((m) => [...m, { role: "assistant", text: data.reply }]);
    } catch {
      setMsgs((m) => [...m, { role: "assistant", text: "Sorry, I'm having trouble. Please email info@eliatravelandtours.co.uk." }]);
    } finally { setBusy(false); }
  };

  return (
    <>
      {!open && (
        <button data-testid="chat-toggle" onClick={() => setOpen(true)}
          className="fixed bottom-5 right-5 z-[60] flex items-center gap-2 group">
          <span className="hidden sm:block bg-white text-[#0B3C5D] text-sm font-semibold px-3 py-2 rounded-full shadow-lg border border-slate-200">Need help? Chat now</span>
          <span className="w-16 h-16 rounded-full bg-white shadow-2xl pulse-ring overflow-hidden border-2 border-[#FF6B35] transition-transform group-hover:scale-105">
            <img src="/chat-avatar.png" alt="Elia Assistant" className="w-full h-full object-cover" />
          </span>
        </button>
      )}

      {open && (
        <button data-testid="chat-toggle" onClick={() => setOpen(false)}
          className="fixed bottom-5 right-5 z-[70] w-14 h-14 rounded-full bg-[#0B3C5D] text-white shadow-2xl flex items-center justify-center">
          <X className="w-6 h-6" />
        </button>
      )}

      {open && (
        <div data-testid="chat-panel" className="fixed bottom-24 right-5 z-[60] w-[92vw] max-w-sm h-[70vh] max-h-[560px] bg-white rounded-2xl shadow-2xl border border-slate-200 flex flex-col overflow-hidden">
          <div className="bg-gradient-to-r from-[#0B3C5D] to-[#134563] text-white px-4 py-3 flex items-center gap-3">
            <span className="w-11 h-11 rounded-full bg-white overflow-hidden border border-white/30 shrink-0"><img src="/chat-avatar.png" alt="" className="w-full h-full object-cover" /></span>
            <div><p className="font-semibold text-sm leading-tight">Elia Assistant</p><p className="text-[11px] text-slate-300 flex items-center gap-1"><span className="w-1.5 h-1.5 rounded-full bg-green-400 inline-block" /> Online · replies instantly</p></div>
          </div>
          <div className="flex-1 overflow-y-auto p-3 space-y-3 bg-slate-50">
            {msgs.map((m, i) => (
              <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
                <div className={`max-w-[80%] rounded-2xl px-3.5 py-2 text-sm whitespace-pre-wrap ${m.role === "user" ? "bg-[#0B3C5D] text-white rounded-br-sm" : "bg-white border border-slate-200 text-slate-700 rounded-bl-sm"}`}>{m.text}</div>
              </div>
            ))}
            {busy && <div className="flex justify-start"><div className="bg-white border border-slate-200 rounded-2xl px-3.5 py-2 text-sm text-slate-400">typing…</div></div>}
            <div ref={end} />
          </div>
          <form onSubmit={send} className="p-3 border-t border-slate-200 flex gap-2">
            <input data-testid="chat-input" value={input} onChange={(e) => setInput(e.target.value)} placeholder="Type your question…"
              className="flex-1 rounded-full border border-slate-200 px-4 py-2 text-sm outline-none focus:ring-2 focus:ring-[#328CC1]" />
            <button data-testid="chat-send" disabled={busy} className="w-10 h-10 rounded-full bg-[#FF6B35] hover:bg-[#e85a26] text-white flex items-center justify-center shrink-0"><Send className="w-4 h-4" /></button>
          </form>
        </div>
      )}
    </>
  );
};
